import { createTheme } from '@mui/material/styles'

function getCssVariable(name: string) {
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim()
}

export const theme = createTheme({
  cssVariables: true,
  palette: {
    primary: {
      main: getCssVariable('--mui-primary-500'),
    },
    secondary: {
      main: getCssVariable('--mui-shades-900'),
    },
    error: {
      main: getCssVariable('--mui-critical-500'),
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          height: '56px',
          borderRadius: '8px',
          textTransform: 'none',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: { borderRadius: '4px' },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { paddingTop: '0px', borderRadius: '8px' },
        input: {
          paddingTop: '12px',
          paddingBottom: '12px',
          paddingLeft: 12,
          paddingRight: 12,
        },
        multiline: { padding: '0' },
        notchedOutline: { borderColor: getCssVariable('--mui-shades-300') },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontFamily: 'SF Pro Display, Helvetica',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: 400,
          letterSpacing: '0px',
          lineHeight: '20px',
        },
      },
    },
  },
  typography: {
    body1: {
      fontFamily: 'SF Pro Display, Helvetica',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 400,
      letterSpacing: '0px',
      lineHeight: '22px',
    },
    body2: {
      fontFamily: 'SF Pro Display, Helvetica',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      letterSpacing: '0px',
      lineHeight: '20px',
    },
    button: {
      fontFamily: 'SF Pro Display, Helvetica',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 600,
      letterSpacing: '0.32px',
      lineHeight: '20px',
    },
    caption: {
      fontFamily: 'SF Pro Display, Helvetica',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 500,
      letterSpacing: '0px',
      lineHeight: '22px',
    },
    h1: {
      fontFamily: 'SF Pro Display, Helvetica',
      fontSize: '34px',
      fontStyle: 'normal',
      fontWeight: 700,
      letterSpacing: '-0.68px',
      lineHeight: '42px',
    },
    h2: {
      fontFamily: 'SF Pro Display, Helvetica',
      fontSize: '28px',
      fontStyle: 'normal',
      fontWeight: 700,
      letterSpacing: '-0.56px',
      lineHeight: '32px',
    },
    h3: {
      fontFamily: 'SF Pro Display',
      fontSize: '20px',
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: '26px',
    },
    h4: {
      fontFamily: 'SF Pro Display, Helvetica',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 700,
      letterSpacing: '0px',
      lineHeight: '22px',
    },
    h5: {
      fontFamily: 'SF Pro Display, Helvetica',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 700,
      letterSpacing: '0px',
      lineHeight: '20px',
    },
    h6: {
      fontFamily: 'SF Pro Display, Helvetica',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 600,
      letterSpacing: '0px',
      lineHeight: '20px',
    },
    // inherit: {
    //   fontFamily: 'SF Pro Display, Helvetica',
    //   fontSize: '16px',
    //   fontStyle: 'normal',
    //   fontWeight: 500,
    //   letterSpacing: '0px',
    //   lineHeight: '22px',
    // },
    overline: {
      fontFamily: 'SF Pro Display, Helvetica',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 700,
      letterSpacing: '0.24px',
      lineHeight: '16px',
    },
    subtitle1: {
      fontFamily: 'SF Pro Display, Helvetica',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '20px',
    },
    subtitle2: {
      fontFamily: 'SF Pro Display, Helvetica',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 500,
      letterSpacing: '0px',
      lineHeight: '16px',
    },
  },
})
